import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, TextAlignTokens, } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Button } from "../../button/Button";
import { Image } from "../../image/Image";
import { Icon } from "../../icon/Icon";
const UserContext500 = ({ height, contactUsAction, triggerAction, retryAPI, loading }) => {
    return (React.createElement(View, { style: [styles.container, { height: height - 16 }] },
        React.createElement(View, { style: styles.insideContainer },
            React.createElement(Image, { size: ImageSizeTokens.Size_330, uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/broken.png", width: 194, height: 150 }),
            React.createElement(Typography, { label: "Oops! Something went wrong", fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, textAlign: TextAlignTokens.center }),
            React.createElement(View, { style: styles.marginTop4 },
                React.createElement(Typography, { label: "Looks like something isn’t right, try refreshing and If the issue still persists, reach out to us", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontWeight: "400", textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: styles.marginTop16 },
                React.createElement(Button, { label: "Reload page", fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, customWidth: 189, type: ButtonTypeTokens.LargeFilled, onPress: () => {
                        triggerAction({
                            ...retryAPI
                        });
                    }, loading: loading }))),
        React.createElement(TouchableOpacity, { style: styles.bottomStack, onPress: () => {
                triggerAction({
                    ...contactUsAction
                });
            } },
            React.createElement(Icon, { name: IconTokens.ContactHeadphones, size: IconSizeTokens.XXL }),
            React.createElement(View, { style: styles.marginLeft4 },
                React.createElement(Typography, { label: "Contact us", fontFamily: FontFamilyTokens.Inter, fontWeight: "500", lineHeight: 16, fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100 })))));
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 36
    },
    marginTop4: {
        marginTop: 4
    },
    insideContainer: {
        justifyContent: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        flex: 1
    },
    marginTop16: {
        marginTop: 16
    },
    bottomStack: {
        bottom: 0,
        position: 'absolute',
        justifyContent: 'center',
        flexDirection: 'row',
        alignSelf: 'center',
        marginBottom: 24,
        alignItems: 'center',
        alignContent: 'center'
    },
    marginLeft4: {
        marginLeft: 4
    }
});
// @ts-ignore
export default (UserContext500);
